import { GRow, GCol, } from '../models/datatable';
import { BreadDik, eAppContext, QueovalBase, Alert } from '../models/global/class.global';
import { AlertCode } from '../models/global/enum.global';
import * as _jquery from 'jquery';
import { CoreService } from '../services/core.service';
import { HttpService } from '../services/dataAccess.service';
import { Router } from '@angular/router';
import { ToastService } from '../toast/toast.service';
import { MergeModel, Select } from '../models/utilities/utilities.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
const $: JQueryStatic = _jquery;

export function DownloadInQrCode(q: CoreService, httpService: HttpService, content: string): Observable<MergeModel> {
  const model: MergeModel = new MergeModel();
  model.PostMode = 'GENERATE_QRCODE';
  model.TextGenere = content;
  return httpService.postHttp<MergeModel>(`${q.AppParams.apiUrl}api/utility`, model).pipe(
    map((result: MergeModel) => {
      if (result.TextGenere) {
        var a = document.createElement("a");
        a.href = "data:image/png;base64," + result.TextGenere;
        a.download = "Image.png";
        a.click();
      }
      return result;
    }
    ))
}

export function setAlertMNG(indParam: CoreService, router: Router, toast: ToastService, model: QueovalBase): void {
  if(model.HasError) {
  let error: string = model.Error.split('|')[0];
  let param: string[] = JSON.parse(JSON.stringify(model.Error.split('|')));
  param.shift();
  error = `${indParam.getTrad(error)} ${param.join(' ')}`;
  console.error(error);
  router.navigate(['view/error']);
}
if (model != null && model.CodedAlerts != null && model.CodedAlerts.length > 0) {

  for (let i: number = 0; i < model.CodedAlerts.length; i++) {
    const alert: Alert = model.CodedAlerts[i];

    ////////if (model.CodedAlerts.filter((a: Alert) => a.Message === alert.Message).length > 1) {
    ////////  model.CodedAlerts.splice(i, 1);
    ////////  i--;
    ////////}

    if (alert.Message.length > 0) {
      let message: string = alert.Message.split('|')[0];
      let param: string[] = JSON.parse(JSON.stringify(alert.Message.split('|')));
      param.shift();
      message = `${indParam.getTrad(message)} ${param.join(' ')}`;
      switch (alert.Code) {
        case AlertCode.ALERT:
          toast.showWarningToast(message, message.length < 100 ? 10000 : message.length * 100);
          break;
        case AlertCode.BLOCKING_ERROR:
          toast.showAlertToast(message, message.length < 100 ? 10000 : message.length * 100);
          break;
        case AlertCode.ERROR:
          toast.showAlertToast(message, message.length < 100 ? 10000 : message.length * 100);
          break;
        case AlertCode.INFO:
          toast.showInfoToast(message, message.length < 30 ? 3000 : message.length * 100);
          break;
        case AlertCode.SUCCESS:
          toast.showSuccessToast(message, message.length < 30 ? 3000 : message.length * 100);
          break;
      }
    }
  }

  model.CodedAlerts = [];
}
  }
export function touchAccepted(e: any, calendar: any = null): void {
  if (isNaN(e.key)) {
    switch (e.key) {
      case 'Backspace': case '/': case 'Tab': case 'ArrowLeft': case 'ArrowRight': case 'Delete':
        break;
      case 'Enter':
        if (calendar) {
          if (calendar.isOpen()) {
            calendar.close();
          }
          else {
            calendar.open();
          }
        }
        break;
      default:
        e.preventDefault();
    }
    //#region deprecated
    //switch (e.which) {
    //  //8: retour arrière | 111: / | 9: tab | 37: flèche gauche | 39: flèche droite | 46: suppr
    //  case 8: case 111: case 9: case 37: case 39: case 46:
    //    break;
    //  //13: entrer
    //  case 13:
    //    if (calendar) {
    //      if (calendar.isOpen()) {
    //        calendar.close();
    //      }
    //      else {
    //        calendar.open();
    //      }
    //    }
    //    break;
    //  default:
    //    e.preventDefault();
    //}
    //#endregion
  }
}

export function TransformStrToDate(value: string): Date | null {
  return !value || value === '' ? null : new Date(value);

}

export function TransformDateToString(value: Date | null): string {
  const resultDate: string = value !== null ? `${value.getFullYear()}-${parseTime(value.getMonth() + 1)}-${parseTime(value.getDate())}` : '';
  return resultDate;
}

export function formatAutoDate<T>(value: string): Date | null {

  let day: string = '';
  let month: string = '';
  let year: string = '';
  // vérification que date ne comporte que des chiffres
  if (!isNaN(Number(value))) {
    // vérification de la taille de la value
    if (value.length === 6 || value.length === 8) {
      day = `${value.substring(0, 2)}`;
      month = `${value.substring(2, 4)}`;
      year = value.length === 6 ? `20${value.substring(4)}` : `${value.substring(4)}`;    
      return  FormatDateToShort(year, month, day);
    }
  } else if (value.length === 10) {
    const regex: any = /^\d{2}\/\d{2}\/\d{4}$/;
    if (regex.test(value)) {
      day = value.split('/')[0];
      month = value.split('/')[1];
      year = value.split('/')[2];     
      return FormatDateToShort(year, month, day);      
    }
  }
  return null;
}

/**
  * Evenement au blur de la date
  * @param e element html
*/
export function testDate(date: Date | null): boolean {
  if (date) {
    return true;
  } else {
    return false;
  }
}

/**
* Genere un id unique
*/
export function generateId(): string {
  return Math.random()
    .toString(36)
    .substr(2, 9);
}

export function splitRoute(approute: string): any {
  const urlParams: any = approute
    .split(/[&||?]/)
    .filter((x: string) => {
      return x.indexOf('=') > -1;
    })
    .map((x: string) => {
      return x.split(/=/);
    })
    .map((x: string[]) => {
      x[1] = x[1].replace(/\+/g, ' ');
      return x;
    })
    .reduce((acc: any, current: any) => {
      acc[current[0]] = current[1];
      return acc;
    }, {});
  return urlParams;
}

export function splitRouteBreadcrumb(approute: string): BreadDik[] {
  const p: BreadDik[] = [];
  const urlParams: string[][] = approute
    .split(/[&||?]/)
    .filter((x: string) => {
      return x.indexOf('=') > -1;
    })
    .map((x: string) => {
      return x.split(/=/);
    })
    .map((x: string[]) => {
      x[1] = x[1].replace(/\+/g, ' ');
      return x;
    });

  if (urlParams) {
    for (let i: number = 0; i < urlParams.length; i++) {
      p.push({ key: urlParams[i][0].replace(/"/g, ''), value: urlParams[i][1].replace(/"/g, '') });
    }
  }

  return p;
}

export function parseTime(time: number): string {
  return time < 10 ? `0${time}` : `${time}`;
}

export function objectIsEmpty(obj: any): boolean {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && key !== null && key !== undefined) {
      return false;
    }
  }
  return true;
}

export function findWhere(array: any, objet: string): any {
  let modal: any;
  for (let i: number = 0; i < array.length; i++) {
    if (array[i].id === objet) {
      modal = array[i];
      break;
    }
  }
  return modal;
}

export function isNullObj<T>(value: T): boolean {
  // return true for value undefined or value null (because undefined == null)
  if (value === null || value === undefined) {
    return true;
  } else {
    return false;
  }
}

export function isEmptyStr(value: string): boolean {
  // return true for: undefined and null (because undefined == null) && value == ""
  if (value === null || value === undefined || value === '') {
    return true;
  } else {
    return false;
  }
}

export function without(array: any, [propertyToRemove]: any): any {
  const array2: any = array;
  for (let i: number = 0; i < array.length; i++) {
    for (let j: number = 0; j < propertyToRemove.length; j++) {
      if (array[i] === propertyToRemove[j]) {
        array2.splice(i, 1);
      }
    }
  }
  return array2;
}

export function isFileNameOk(titre: string): string {
  //  var regex = /[$&+,:;=?@#|'<>^*%!-]/g;
  const regex: RegExp = /[$&+,:;=?@#|'<>^*%!]/g;
  let result: string = 'ok';
  if (!isEmptyStr(titre)) {
    const m: RegExpMatchArray | null = titre.match(regex);
    if (m) {
      result = '';
      for (const r of m) {
        result += r;
      }
    }
  }
  return result;
}

/** @description encode a string into base 64 format (web compliant)
  * @return string base 64 convertion result
  */
export function b64EncodeUnicode(str: string): string {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match: string, p1: any) => {
    return String.fromCharCode(('0x' + p1) as any);
  }));
}

/** @description encode a string into base 64 format (web compliant) and replace specials characters to pass inside route
  * @return string base 64 convertion result
  */
export function b64UrlEncodeUnicode(str: string): string {
  var b64: string = btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match: string, p1: any) => {
    return String.fromCharCode(('0x' + p1) as any);
  }));

  b64 = b64.replace(/\//g, '_').replace(/\+/g, '-');
  return b64;
}

/** @description decode a base 64 string into a normal string (web compliant)
  * @return string convertion result
  */
export function b64DecodeUnicode(str: string): string {
  return decodeURIComponent(Array.prototype.map.call(atob(str), (c: any) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export function b64UrlDecodeUnicode(str: string): string {
  var b64 = str.replace(/\_/g, '/').replace(/\-/g, '+');
  return decodeURIComponent(Array.prototype.map.call(atob(b64), (c: any) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

/** @description return the column value from the specified row
 * @param GRow row row to query for column value
 * @param string fieldName column name
 * @return string correspondent value
 */
export function GetColValue(row: GRow, fieldName: string): string {
  if (row && row.Cols) {
    const c: GCol[] = row.Cols.filter((e: GCol) => e.ColName === fieldName);
    return c && c.length > 0 ? c[0].ColValue : 'nf';
  }
  return '';
}

export function formatMoneyString(value: string, culture: string): string {
  let result: string = value;
  switch (culture.toUpperCase()) {
    case 'GB-EN':
      if (result === '' || result === '0')
        result = '0.00';
      else {
        if (result.indexOf('.') === - 1)
          result += '.00';
        else {
          const st: string[] = result.split('.');
          if (st[1].length === 2) {

          }
          else if (st[1].length > 2) {
            st[1] = st[1].substring(0, 2);
          }
          else if (st[1].length < 2) {
            for (let n: number = st[1].length; n < 3; n++) {
              st[1] = `${st[1]}0`;
            }
          }
          result = `${st[0]}.${st[1]}`;
        }
      }
      break;
    case 'FR-FR':
    default:
      if (result === '' || result === '0')
        result = '0,00';
      else {
        if (result.indexOf(',') === - 1)
          result += ',00';
        else {
          const st: string[] = result.split(',');
          if (st[1].length === 2) {

          }
          else if (st[1].length > 2) {
            st[1] = st[1].substring(0, 2);
          }
          else if (st[1].length < 2) {
            for (let n: number = st[1].length; n < 3; n++) {
              st[1] = `${st[1]}0`;
            }
          }
          result = `${st[0]},${st[1]}`;
        }
      }
      break;
  }
  return result;
}

export function transformDateToQueovalDate(d: Date | null): any {
  let date: Date;
  if (d) {
    date = new Date(d);
    return {
      annee: String(date.getFullYear()),
      mois: String(date.getMonth() + 1),
      jour: String(date.getDate())
    };
  } else {
    return {
      annee: '0',
      mois: '0',
      jour: '0'
    };
  }
}

export function transformQueovalDateToDateOrNull(d: any): Date | null {
  if (d.annee === '0') {
    return null;
  } else {
    return FormatDateToShort(d.annee, d.mois, d.jour);
  }
}

export function transformQueovalDateToDate(d: any): Date {
  if (d.annee === '0') {
    return new Date();
  } else {   
    return FormatDateToShort(d.annee,d.mois, d.jour);
  }
}

export function FormatDateToShort(annee: any, mois: any, jour: any): Date {
  const isUTC: boolean = false;

  let dt: Date = new Date();
  if (isUTC)
    dt = new Date(Date.UTC(Number(annee), Number(mois) - 1, Number(jour)));
  else
    dt = new Date(Number(annee), Number(mois) - 1, Number(jour));

  return dt;
}

//export function FormatAbbreviatedDateToShort(strDate: string): Date | null {
//  function DateValideOrNull(date: Date): Date | null {
//    if (Object.prototype.toString.call(date) === '[object Date]') {
//      // it is a date
//      if (isNaN(date.getTime())) {
//        return null;
//      } else {
//        return date;
//      }
//    } else {
//      console.error(`${strDate} n'est pas un format de date valide.`);
//      return null;
//    }
//  }

//  if (strDate.substring(0, 2) === '00') {
//    return DateValideOrNull(new Date(`20${strDate.substring(2)}`));
//  } else {
//    return DateValideOrNull(new Date(strDate));
//  }
//}

export function FormatAbbreviatedDateToShort(pStrDate: string): Date {
  // déclaration de la date du jour
  const dateOfDay: Date = new Date();
  const dayOfDay: number = dateOfDay.getDate();
  const monthOfDay: number = dateOfDay.getMonth() + 1;
  const yearOfDay: number = dateOfDay.getFullYear();

  // renvoie la date du jour si la date récupérée est 0000-00-00
  const lstDate: Array<string> = pStrDate.split('-');
  let year: number = Number(lstDate[0]);
  //si l'année = '0000' => année en cours || si l'année < 100 => 20XX (XX compris entre 01 et 99) || sinon => valeur saisie
  year = lstDate[0] === '0000' ? yearOfDay : year < 100 ? Number(`20${parseTime(year)}`) : Number(lstDate[0]);
  const month: number = lstDate[1] === '00' ? monthOfDay : Number(lstDate[1]);
  const day: number = lstDate[2] === '00' ? dayOfDay : Number(lstDate[2]);

  // les mois sont décalés de 1 à cause du rang du premier argument d'une liste qui est 0
  return FormatDateToShort(year, month, day);

}


export function PadLeft(value: number, size: number): string {
  let s: string = `${value}`;
  while (s.length < size) {
    s = `0${s}`;
  }
  return s;
}

export function GetHeaderHeight(context: eAppContext): number {
  const winW: number | undefined = $(window).width();
  const isMobile: boolean = winW && winW <= 768 ? true : false;
  switch (context) {
    case eAppContext.QUEOVAL: return 112;
    case eAppContext.EXTRANET: return !isMobile ? 105 : 45;
    case eAppContext.ELEARNING: return 48;
    default: return 0;
  }
}

export function compareValues(key: string, order: string = 'asc') {
  return function innerSort(a: any, b: any): number {
    if (!Reflect.has(a, key) || !Reflect.has(b, key))
      return 0;
    //////////if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
    //////////  // property doesn't exist on either object
    //////////  return 0;
    //////////}
    

    const varA: any = (typeof a[key] === 'string')
      ? a[key].toUpperCase() : a[key];
    const varB: any = (typeof b[key] === 'string')
      ? b[key].toUpperCase() : b[key];

    let comparison: number = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}

export function EndWithSlash(path: string): string {
  return path.substring(path.length - 1) === '/'
    ? path
    : `${path}/`;
}

export function AddEmptyLine<T extends Select>(tableResult: T[] | null, hasNullValue: boolean = true): void {
  const r: any = { id: '0', value: '--------' };
  if (!tableResult) {
    tableResult = [r];
  }
  else {
    if (hasNullValue) {
      tableResult.unshift(r);
    }
  }

}

export function VerifyAndAffectIfValue<T extends Select>(tableResult: T[], affect: T): void {
  for (const prop of tableResult) {
    if (prop.id === affect.id) {
      prop.value = affect.value;
      break;
    }
  }
}

